export const pointerEventAutoStyle = `
  pointer-events: auto;
`;
export const pointerEventsNoneStyle = `
  pointer-events: none;
`;